import { Criterion } from "./criterion.js";
/**
 * This namespace defines types and functions for working with conformance-
 * related queries.
 *
 * {@link https://www.w3.org/TR/WCAG/#conformance}
 *
 * @public
 */
export var Conformance;
(function (Conformance) {
    /**
     * Check if a criterion is needed for the specified conformance level under
     * the specified version.
     */
    function hasLevel(level, version = Criterion.Version.Recommendation) {
        return (criterion) => criterion.level.some((found, versions) => found <= level && [...versions].includes(version));
    }
    /**
     * Check if a criterion is needed for level AA conformance under the
     * specified version.
     */
    function isA(version) {
        return hasLevel("A", version);
    }
    Conformance.isA = isA;
    /**
     * Check if a criterion is needed for level AA conformance under the
     * specified version.
     */
    function isAA(version) {
        return hasLevel("AA", version);
    }
    Conformance.isAA = isAA;
    /**
     * Check if a criterion is needed for level AAA conformance under the
     * specified version.
     */
    function isAAA(version) {
        return hasLevel("AAA", version);
    }
    Conformance.isAAA = isAAA;
})(Conformance || (Conformance = {}));
//# sourceMappingURL=conformance.js.map